import { render } from "./FormSendLink.vue?vue&type=template&id=f6fed5e8&scoped=true"
import script from "./FormSendLink.vue?vue&type=script&lang=js"
export * from "./FormSendLink.vue?vue&type=script&lang=js"

import "./FormSendLink.vue?vue&type=style&index=0&id=f6fed5e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6fed5e8"]])

export default __exports__